/* eslint-disable no-unused-vars */
import {
  CustomFlowbiteTheme,
  Tooltip as FlowbiteTooltip,
  TooltipProps,
} from 'flowbite-react'

const customTheme: CustomFlowbiteTheme['tooltip'] = {
  target: 'w-fit',
  animation: 'transition-opacity',
  arrow: {
    base: 'absolute z-10 h-2 w-2 rotate-45',
    style: {
      dark: 'bg-primary-900 dark:bg-gray-700',
      light: 'bg-white',
      auto: 'bg-white dark:bg-gray-700',
    },
    placement: '-4px',
  },
  base: 'absolute inline-block z-10 rounded-md py-2 px-3 text-sm font-normal shadow-sm',
  hidden: 'invisible opacity-0',
  style: {
    dark: 'bg-primary-900 text-white dark:bg-gray-700',
    light: 'bg-white text-[#434343] font-normal shadow-boutons-light',
    auto: 'border border-gray-200 bg-white text-gray-900 dark:border-none dark:bg-gray-700 dark:text-white',
  },
  content: 'relative z-20',
}

const Tooltip = ({ children, ...rest }: TooltipProps) => (
  <FlowbiteTooltip
    // @ts-ignore
    theme={customTheme}
    {...rest}
  >
    {children}
  </FlowbiteTooltip>
)

export default Tooltip
